import { render } from "./SubmitFormModal.vue?vue&type=template&id=3129638a&scoped=true"
import script from "./SubmitFormModal.vue?vue&type=script&lang=js"
export * from "./SubmitFormModal.vue?vue&type=script&lang=js"

import "./SubmitFormModal.vue?vue&type=style&index=0&id=3129638a&lang=scss&scoped=true"

import exportComponent from "../../../.yarn/__virtual__/vue-loader-virtual-57de6a73e2/0/cache/vue-loader-npm-17.4.2-00674d01e5-88760fe6a5.zip/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3129638a"]])

export default __exports__